declare module '*.st.css';
declare module 'hoist-non-react-methods';
